<template>
  <div class="screen screen__forgot_password screen__background-card">
    <div class="page--container">
      <div class="page--section">
        <el-card class="card card__login">
          <div v-show="!successEmail">
            <header class="card__header">
              <h1 class="h2 card__title">{{$t('applicationSignUp')}}</h1>
              <p class="card__paragraph">{{$t('pageDescriptionSignUp')}}</p>
            </header>
            <sign-up-form
              v-on:success="onSuccess"
            />
          </div>

          <div v-show="successEmail">
            <header class="card__header">
              <h1 class="h2 card__title">{{$t('authenticationSuccess')}}</h1>
            </header>
            <p class="card__paragraph">
              {{$t('authenticationSuccessEmailSent')}}
            </p>
            <p class="card__paragraph card__paragraph-emphasized">
              <b>{{successEmail}}</b>
            </p>
            <p class="card__paragraph">
              {{$t('authenticationSuccessEmailActivate')}}
            </p>
            <div class="card__footer">
              <p class="card__footer_footnote">
                <span>{{$t('authenticationSuccessEmailIncorrect')}}</span>
                <a class="card__footer_link" v-on:click.capture="successEmail = null">
                  {{$t('authenticationSuccessEmailEdit')}}
                </a>
              </p>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import SignUpForm from '@/components/SignUpForm.vue';

  export default {
    name: 'SignUp',
    data() {
      return {
        successEmail: null
      }
    },
    methods: {
      onSuccess(email) {
        this.successEmail = email
      },
    },
    components: {
      SignUpForm
    }
  }
</script>

<style lang="scss" scoped>
  .card__header {
    position: relative;
  }
  .card__paragraph {
    font-size: 14px;
    margin: 0 0 10px;
  }
  .card__paragraph-emphasized {
    font-weight: bold;
    font-size: 20px;
  }
</style>
